var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['van-doc-simulator', { 'van-doc-simulator-fixed': _vm.isFixed }]},[_c('iframe',{ref:"iframe",style:(_vm.simulatorStyle),attrs:{"src":_vm.src,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }